export const dataCAR = [
  {
    id: 1,
    imgUrl: "11.png",
    alt: "siceen21",
    url: "https://siceen21.ine.mx/home",
    itemActive: "",
  },
  {
    id: 2,
    imgUrl: "apoyo_ciudadano.png",
    alt: "Apoyo ciudadano",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/apoyo_ciudadano.png",
    itemActive: "",
  },
  {
    id: 3,
    imgUrl: "0.png",
    alt: "Convocatoria OPPMT",
    url: "https://www.observatoriomujerestlaxcala.mx/contents/",
    itemActive: "",
  },
  {
    id: 4,
    imgUrl: "RedMujeres.webp",
    alt: "Red Mujeres (formulario)",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdZb2vkV6LQwamOR7zY3XC_gIHwkq-qbuQoAiWm6rQWQx6Ktg/viewform",
    itemActive: "",
  },
  {
    id: 5,
    imgUrl: "cddlm.jpg",
    alt: "Cartilla de derechos de las mujeres",
    url: "https://www.cartilladerechosdelasmujeres.gob.mx",
    itemActive: "",
  },
  {
    id: 6,
    imgUrl: "baner2_convocatoria_consulta.webp",
    alt: "",
    url: "https://www.iepcgro.mx/principal/sitio/sistemas_normativos_internos#acordeonEtapas",
    itemActive: "",
  },
  {
    id: 7,
    imgUrl: "banner_ieem.jpg",
    alt: "",
    url: "https://itetlax.org.mx/assets/pdf/agenda/Convocatoria_XXIX.pdf",
    itemActive: "",
  },
  {
    id: 8,
    imgUrl: "banner_ine_m.jpg",
    alt: "",
    url: "https://forms.office.com/pages/responsepage.aspx?id=s_aEj274YUiwaktieD60P_Clt1eTfM9LntsvJCK-tH5UMUM5MEFMVVZaTkNQQjI1MTZFUThUN0VKVC4u&route=shorturl",
    itemActive: "active",
  },
];


export const dataCA = [
  {
    id: "ca-1",
    imgUrl: "7.jpg",
    alt: "Participación Política de las mujeres tlaxcaltecas (libro OPPMT)",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/carousel/libroOPPMT.pdf",
    linkTo: "",
  },
  {
    id: "ca-2",
    imgUrl: "46.jpg",
    alt: "Faro Democrático 46",
    url: "https://farodemocratico.ine.mx/",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-3",
    imgUrl: "47.jpg",
    alt: "Faro Democrático 47",
    url: "https://farodemocratico.ine.mx/",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-4",
    imgUrl: "48.jpg",
    alt: "Faro Democrático 48",
    url: "https://farodemocratico.ine.mx/",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-5",
    imgUrl: "49.jpg",
    alt: "Faro Democrático 49",
    url: "https://farodemocratico.ine.mx/",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-6",
    imgUrl: "50.jpg",
    alt: "Faro Democrático 50",
    url: "https://farodemocratico.ine.mx/",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  
  {
    id: "ca-7",
    imgUrl: "cijg.jpg",
    alt: "CIJG imagen",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/cijg.jpg",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-8",
    imgUrl: "cij35.jpg",
    alt: "CIJ 35",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/cij35.jpg",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-9",
    imgUrl: "cij69.jpg",
    alt: "CIJ 69",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/cij69.jpg",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-10",
    imgUrl: "cij1013.jpg",
    alt: "CIJ 1013",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/cij1013.jpg",
    linkTo: "",
    itemActive: "",
    buttonActive: "",
  },
  {
    id: "ca-11",
    imgUrl: "cij1417.jpg",
    alt: "CIJ 1417",
    itemActive: "active",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/cij1417.jpg",
    linkTo: "",
  },
];
